module.exports = __webpack_public_path__ + "static/NavisworksLogo-a8b8e92dee4a1b503467d1d6b15b945a.png";